import { NextPage } from 'next'
import { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import { Box } from '@mui/material'
import { NewsDetailUrl } from '../common/url'
import ReactLoading from 'react-loading'
import { isTablet } from 'react-device-detect'
import { ScreenWidthPort } from '../ScreenWidthContext'

const ExternalHtmlWithScript = ({ htmlContent }) => {

    const containerRef = useRef(null)
    const hasScriptLoaded = useRef(false)
    
    useEffect(() => {
        // 设置最小缩放比例为1.0，禁止缩小但允许放大
        const meta = document.createElement('meta')
        meta.name = 'viewport'
        meta.content = 'width=device-width, initial-scale=1.0, minimum-scale=1.0'
        document.getElementsByTagName('head')[0].appendChild(meta)
        
        return () => {
        // 清理时恢复默认viewport
        const metas = document.getElementsByTagName('meta')
        for (let i = 0; i < metas.length; i++) {
            if (metas[i].name === 'viewport') {
            metas[i].content = 'width=device-width, initial-scale=1.0'
            break
            }
        }
        }
    }, [])


    useEffect(() => {
        if (!containerRef.current || hasScriptLoaded.current) return

        // 查找所有 TikTok 嵌入块
        const tiktokBlocks = containerRef.current.querySelectorAll('.tiktok-embed')
        if (!tiktokBlocks.length) return

        // 动态加载 TikTok 脚本
        const loadTiktokScript = () => {
        if (window.tiktokEmbed) return

        const script = document.createElement('script')
        script.src = 'https://www.tiktok.com/embed.js'
        script.async = true
        script.onload = () => {
            window.tiktokEmbed?.init()
        }
        document.body.appendChild(script)
        hasScriptLoaded.current = true
        }

        // 为每个 TikTok 块设置观察器
        const observers = []
        tiktokBlocks.forEach((block) => {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
            loadTiktokScript()
            observer.disconnect()
            }
        }, { threshold: 0.1 })
        observer.observe(block)
        observers.push(observer)
        })

        return () => {
        observers.forEach(observer => observer.disconnect())
        }
    }, [])

    // 安全渲染完整 HTML 内容
    const createMarkup = () => {
        // 智能表格处理
        return {
            __html: htmlContent
            .replace(/<table([^>]*)>/g, '<table class="smart-table"$1 style="width:100%!important;">')
            .replace(/<(td|th)([^>]*)>/g, '<$1$2 style="white-space:normal!important;word-break:break-word!important;">')
            .replace(/<blockquote class="tiktok-embed"/g, '<div class="tiktok-video-container"><blockquote class="tiktok-embed"')
        }
    }

    return (
    <div className="content-container">
        <div 
        ref={containerRef}
        dangerouslySetInnerHTML={createMarkup()}
        />

        <style jsx>{`
        /* 基础容器 */
        .content-container {
            max-width: 100%;
            font-family: Arial, sans-serif;
            padding: 0 10px;
        }

        /* 文字内容样式 */
        .content-container h2 {
            font-size: 24px;
            margin: 1.5em 0 0.8em;
            text-align: center;
        }
        .content-container h3 {
            font-size: 20px;
            margin: 1.2em 0 0.6em;
        }
        .content-container p {
            margin-bottom: 1em;
        }
        // .content-container ul {
        //     margin-bottom: 1em;
        //     margin-bottom: 20px;
        // }
        .content-container li {
            margin-bottom: 0.5em;
            margin-left: 20px;
        }
        .content-container strong {
            font-weight: bold;
        }

        /* TikTok视频专用样式 - 完全独立 */
        .tiktok-video-container {
            margin: 20px auto !important;
            width: 100% !important;
            max-width: 605px !important;
            min-width: 325px !important;
            overflow: visible !important;
        }
        .tiktok-video-container > iframe,
        .tiktok-video-container > blockquote {
            width: 100% !important;
            height: 740px !important;
            min-height: 740px !important;
            border: none !important;
            display: block !important;
            margin: 0 !important;
            padding: 0 !important;
        }


        /* 表格容器 */
        .smart-table-container {
            max-width: 100%;
            /* margin: 0 auto; */
            /* padding: 1%; */
            font-family: Arial, sans-serif;
            overflow: hidden; /* 防止内容溢出 */
        }

        /* 表格强制适应策略 */
        .smart-table {
            width: 100% !important;
            max-width: 100%;
            border-collapse: collapse;
            table-layout: auto; /* 自动调整列宽 */
            margin: 5px 0;
        }
        .smart-table ul {
            list-style-position: inside; /* 横线对齐单元格左边 */
            margin-left: 0px; /* 适当间距 */
        }
        .smart-table li {
            list-style-position: inside; /* 横线对齐单元格左边 */
            margin-left: 5px; /* 适当间距 */
        }

        /* 处理列宽设置 */
        .smart-table colgroup,
        .smart-table col {
            width: auto !important; /* 覆盖内联列宽 */
        }

        /* 单元格移动端优化 */
        .smart-table td,
        .smart-table th {
            padding: 2px;
            border: 1px solid #ddd;
            min-width: 30px; /* 防止列过窄 */
            white-space: normal !important; /* 强制换行 */
            word-break: break-word; /* 长单词或 URL 换行 */
            overflow-wrap: break-word; /* 防止内容溢出 */
        }

        
        /* 自动调整列宽 */
        .smart-table td:first-child,
        .smart-table th:first-child {
            width: auto; /* 首列自适应 */
        }
        .smart-table td:not(:first-child),
        .smart-table th:not(:first-child) {
            min-width: 50px; /* 其他列最小宽度 */
        }

        /* 移动端适配 - 合并两者 */
        @media (max-width: 600px) {
          /* 小屏幕下表格横向滚动 */
          .smart-table {
            display: block;
            table-layout: fixed; /* 自动调整列宽 */
            white-space: normal !important; /* 强制换行 */
            word-break: break-word; /* 强制内容换行 */
            overflow-wrap: break-word; /* 防止内容溢出 */
          }
    
          .smart-table ol {
            padding-left: 16px;
            padding-right: 5px;
          }

          /* 缩小字体 */
          .smart-table td,
            .smart-table th {
            font-size: 8px;
            padding: 2%;
          }

          .tiktok-video-container {
            width: calc(100% - 20px) !important;
          }
          .tiktok-video-container > iframe,
          .tiktok-video-container > blockquote {
            height: 740px !important;
            min-height: 740px !important;
          }
          .raw-html-embed a {
            padding: 10px 12px !important; 
            height: auto !important; /* 取消固定高度，允许自适应换行 */
            line-height: 1.2 !important; /* 文字行间距舒适 */
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            box-sizing: border-box !important;
            text-align: center !important;
            margin: 5px 5px !important;
          }
          .raw-html-embed a span {
            font-size: 16px !important;
          }
        }

        /* 防止样式冲突 */
        .tiktok-video-container table,
        .tiktok-video-container td,
        .tiktok-video-container th {
            all: revert !important;
        }
        `}</style>
    </div>
    )
}

export const AppNewsDetail: NextPage = () => {

    const { showDesktopUI } = ScreenWidthPort()
    
    const [data, setData] = useState(null)

    const containerRef = useRef(null)

    // 动态修复表格样式
    useEffect(() => {
        if (containerRef.current) {
          // 移除所有内联样式
          const tables = containerRef.current.querySelectorAll('table')
          tables.forEach(table => {
            table.removeAttribute('style') // 移除内联样式
            table.style.width = '100%' // 强制设置宽度为 100%
          })
    
          // 移除列宽设置
          const cols = containerRef.current.querySelectorAll('col')
          cols.forEach(col => {
            col.removeAttribute('style')
            col.removeAttribute('width')
          })
    
          // 移除所有内联单元格宽度
          const cells = containerRef.current.querySelectorAll('td, th')
          cells.forEach(cell => {
            cell.removeAttribute('style')
            cell.removeAttribute('width')
          })
        }
      }, [])

    useEffect(() => {
        let mounted = true
        const fetchData = async () => {
            try {
                const id = new URL(window.location.href).searchParams.get('id')
                if (id !== null) {
                    try {
                        const response = await axios.get(NewsDetailUrl + id)
                        if (mounted) {
                            setData(response.data['data'])
                        }
                    } catch (error) {
                        console.error(error)
                    }
                }
            } catch (error) {
                console.error(error)
            }
        }

        fetchData()

        return () => {
            mounted = false
        }
    }, [])

    return (
        <>
            {data === null ?
                (<Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    paddingTop: '200px',
                    paddingBottom: '200px',
                    justifyContent: 'center',
                    alignContent: 'center',
                    alignItems: 'center'
                }}>
                    <ReactLoading type={'spokes'} width={'32px'} height={'32px'} color={'#FFC107'}></ReactLoading>
                </Box>)
                :
                (showDesktopUI ? (<Box sx={{ paddingLeft: '120px', paddingRight: '120px', paddingTop: '30px', paddingBottom: '30px' }}>
                    <div >
                        <ExternalHtmlWithScript htmlContent={'<div id="preview" class="ck-content">' + data['attributes']['details'] + '</div>'} />
                    </div>
                </Box>) : (<Box sx={{ paddingLeft: isTablet ? '12px' : '0px', paddingRight: isTablet ? '12px' : '0px', paddingTop: '10px', paddingBottom: '30px' }}>
                    <div >
                        <ExternalHtmlWithScript htmlContent={'<div id="preview" class="ck-content">' + data['attributes']['details'] + '</div>'} />
                    </div>
                </Box>)
                )
            }
        </>
    )
}
